import React from 'react';

import { NestedNumberedList } from '../components/NestedNumberedList';
import { Paragraph } from '../components/Paragraph';
import { Title } from '../components/Title';
import { acceptableSiteUsesMessages } from './messages/acceptableSiteUses';
import { dealingWithAdvertisersMessages } from './messages/dealingWithAdvertisers';
import { dealingWithOtherUsersMessages } from './messages/dealingWithOtherUsers';
import { definitionsMessages } from './messages/definitions';
import { disclaimerMessages } from './messages/disclaimer';
import { entireAgreementMessages } from './messages/entireAgreement';
import { forceMajeureMessages } from './messages/forceMajeure';
import { governingLawAndJurisdictionMessage } from './messages/governingLawAndJurisdiction';
import { indemnityMessages } from './messages/indemnity';
import { intellectualPropertyRightsMessages } from './messages/intellectualPropertyRights';
import { limitationOfLiabilityMessages } from './messages/limitationOfLiability';
import { linksToOtherWebsitesMessage } from './messages/linksToOtherWebsites';
import { modificationToAccessOrSiteMessages } from './messages/modificationToAccessOrSite';
import { ownRiskMessages } from './messages/ownRisk';
import { responsibilityMessages } from './messages/responsibility';
import { securityMeasuresMessages } from './messages/securityMeasures';
import { severabilityMessages } from './messages/severability';
import { terminationMessages } from './messages/termination';
import { variationOfTermsMessages } from './messages/variationOfTerms';

const nestedNumberedListData = {
  list: [
    definitionsMessages,
    acceptableSiteUsesMessages,
    intellectualPropertyRightsMessages,
    responsibilityMessages,
    ownRiskMessages,
    linksToOtherWebsitesMessage,
    indemnityMessages,
    disclaimerMessages,
    dealingWithAdvertisersMessages,
    dealingWithOtherUsersMessages,
    limitationOfLiabilityMessages,
    terminationMessages,
    modificationToAccessOrSiteMessages,
    securityMeasuresMessages,
    governingLawAndJurisdictionMessage,
    forceMajeureMessages,
    entireAgreementMessages,
    severabilityMessages,
    variationOfTermsMessages,
  ],
};

export const TermsOfUse = () => {
  return (
    <>
      <Title>Terms of Use</Title>
      <Paragraph>
        Services provided by Glints Pte Ltd through the Site therein shall be
        available to Job Seekers or other users such as Advertisers. Access to
        and use of the contents and services provided on the Site shall be
        subject to the term and conditions which are set out below (“Terms and
        Conditions”) and the privacy statement (“Privacy Statement”).
      </Paragraph>
      <Paragraph>
        If you do not accept either or both of the Terms and Conditions and/or
        the Privacy Statement, please do not join, access, view, download or
        otherwise use any services offered by Glints Pte Ltd via the Site. By
        your continued use of the Site, you acknowledge that you have read and
        understood the Terms and Conditions and the Privacy Statement and that
        you agree to be bound by all of its provisions. Glints Pte Ltd reserves
        the right to amend, add to, delete or revise the Privacy Statement and
        the Terms and Conditions at any time without prior notice. You are
        advised to periodically review the Privacy Statement and the Terms and
        Conditions. Your access to the Site and Glints Pte Ltd’s services will
        be terminated upon your notice to Glints Pte Ltd that any change is
        unacceptable; otherwise your continued use shall constitute your
        acceptance of all changes and they shall be binding upon you.
      </Paragraph>
      <NestedNumberedList data={nestedNumberedListData} />
    </>
  );
};
